<template>
  <div>
    <div>
      <div class="page-content">
        <div class="container-fluid">
          <vk-offcanvas-content>
            <vk-button @click="show = true">Open</vk-button>
            <div>
              <vk-offcanvas flipped overlay :show.sync="show">
                <vk-offcanvas-close @click="show = false"></vk-offcanvas-close>
                <h3>Title</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
              </vk-offcanvas>
            </div>
          </vk-offcanvas-content>
          <div class="main-container">
            <div class="row">
              <div class="page-content__header-description col-md-12">Modal</div>
              <!-- ======================= -->
              <b-button @click="showModal">Open Modal</b-button>
              <b-modal
                centered
                ref="myModalRef"
                hide-footer
                class="modal-dialog modal-content"
                role="document"
              >
                <div slot="modal-header" style="text-align: center !important;">
                  <b-btn
                    class="close custom-modal__close"
                    style="justify-content: center !important; font-size: .89em;"
                    @click="hideModal"
                  >
                    <span aria-hidden="true" class="fa fa-close"></span>
                  </b-btn>
                  <img src="/static/img/modal/4.png" alt class />
                  <h2 class="page-content__header-description">My Modal Component</h2>
                </div>
                <div class="d-block text-center">
                  <h3>Hello From My Modal!</h3>
                </div>
              </b-modal>
            </div>

            <!-- ================================= Grid -->
            <div class="row">
              <div class="page-content__header-description col-md-12">Grid Overview Display</div>
              <!-- ======================= -->
              <div class="col-xl-3 col-lg-3 col-md-3 text-center">
                <div class="widget_box">
                  <figcaption>
                    <h3>Panels (80watts)</h3>
                    <p>{{random_num('inverter_number')}}</p>
                  </figcaption>
                </div>
              </div>
              <!-- ======================= -->
              <div class="col-xl-3 col-lg-3 col-md-3 text-center">
                <div class="widget_box">
                  <figcaption>
                    <h3>Inverter (3000watts)</h3>
                    <p>{{random_num('inverter_number')}}</p>
                  </figcaption>
                </div>
              </div>
              <!-- ======================= -->
              <div class="col-xl-3 col-lg-3 col-md-3 text-center">
                <div class="widget_box">
                  <figcaption>
                    <h3>Pole</h3>
                    <p>{{random_num('inverter_number')}}</p>
                  </figcaption>
                </div>
              </div>
              <!-- ======================= -->
              <div class="col-xl-3 col-lg-3 col-md-3 text-center">
                <div class="widget_box">
                  <figcaption>
                    <h3>Table</h3>
                    <p>{{random_num('inverter_number')}}</p>
                  </figcaption>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="page-content__header-description col-md-12">Info Banner</div>
              <!-- ======================= -->
              <div class="modal-dialog" role="document">
                <button
                  type="button"
                  class="close custom-modal__close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" class="ua-icon-modal-close"></span>
                </button>
                <div class="modal-content">
                  <div class="modal-header custom-modal__image">
                    <img src="/static/img/modal/2.png" alt class />
                  </div>
                  <div class="modal-body custom-modal__body">
                    <h4 class="custom-modal__body-heading">Setup Fee Payment</h4>
                    <div
                      class="custom-modal__body-desc"
                    >Just a step to go. Click the button below to make payment</div>
                  </div>
                  .sh {
                  // display: table-cell;
                  }
                  <div class="modal-footer" style="flex-flow: column;">
                    <div class="custom-modal__buttons">
                      <button
                        class="btn btn-info iconfont icon-left custom-modal__icon-btn"
                        type="button"
                      >
                        Proceed
                        <span class="btn-icon fa fa-mouse-pointer"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-form ref="form" :model="form" label-width="120px">
              <el-form-item label="Activity name">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="Activity zone">
                <el-select v-model="form.region" placeholder="please select your zone">
                  <el-option label="Zone one" value="shanghai"></el-option>
                  <el-option label="Zone two" value="beijing"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-tag
                  :key="tag"
                  v-for="tag in dynamicTags"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                >
                {{tag}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="mini"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                ></el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="onSubmit">Create</el-button>
                <el-button>Cancel</el-button>
              </el-form-item>
            </el-form>
            <!-- <div class="row">
              <div class="page-content__header-description col-md-12">Table</div>
              =======================
              <div style="width: 100%;">
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :paginate="true"
                  styleClass="table table-striped col-md-12"
                >
                  <template slot="table-row" slot-scope="props">
                    <td data-label="fullname" class="fancy">{{ props.row.name }}</td>
                    <td data-label="Age" class="has-text-right">{{ props.row.age }}</td>
                    <td data-label="Joined On" class="has-text-right">{{ props.row.joined }}</td>
                  </template>

                </vue-good-table>
                <vue-good-table
                  :pagination-options="{enabled: true}"
                  @on-select-all="selectAll"
                  @on-row-click="toggleSelectRow"
                  :columns="columns"
                  :rows="rows"
                  :select-options="{ enabled: true }"
                  :search-options="{ enabled: true }"
                ></vue-good-table>
              </div>
            </div>
            <div class="row">
              <el-col :span="12">
                <div class="sub-title">list suggestions when activated</div>
                <el-autocomplete
                  class="inline-input"
                  v-model="state1"
                  :fetch-suggestions="querySearch"
                  placeholder="Please Input"
                  @select="handleSelect"
                ></el-autocomplete>
              </el-col>
            </div>-->
          </div>
        </div>
        <!-- <div v-for="item in results" v-bind:key="item.Id">{{ item }}</div> -->
        <!-- <table>
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Description</th>
              <th>Active</th>
              <th>Taxable</th>
              <th>Unit Price(₦)</th>
              <th>Sales Price(₦)</th>
              <th>Inv Start Date</th>

              <th>Type</th>
              <th>Track Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in results" :key="item.Id">
              <td>{{ item.Id }}</td>
              <td>{{ item.Name }}</td>
              <td>{{ item.Description }}</td>
              <td>{{ item.Active }}</td>
              <td>{{ item.Taxable }}</td>
              <td>{{ item.QtyOnHand }}</td>
              <td>{{ item.UnitPrice }}</td>
              <td>{{ item.InvStartDate }}</td>
              <td>{{ item.Type }}</td>
              <td>{{ item.TrackQtyOnHand }}</td>
            </tr>
              For one item by changing res.data.QueryResponse.Item to res.data.QueryResponse.Item[0]
              <tr>
                <td>{{ results.Id }}</td>
                <td>{{ results.Name }}</td>
                <td>{{ results.Description }}</td>
                <td>{{ results.Active }}</td>
                <td>{{ results.Taxable }}</td>
                <td>{{ results.UnitPrice }}</td>
                <td>{{ results.Type }}</td>
                <td>{{ results.TrackQtyOnHand }}</td>
              </tr>
          </tbody>
        </table>-->
      </div>

      <!-- <div>
        
      </div>-->
      <!-- <button class="test">List item</button> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import {
  Select,
  Button,
  Form,
  FormItem,
  Tag
  // ...
} from "element-ui";
// import "vue-good-table/dist/vue-good-table.css";
// import { VueGoodTable } from "vue-good-table";

export default {
  data() {
    return {
      form: {
        name: "",
        region: "",
        inputValue:this.dynamicTags
      },
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      results: []

      // columns: [
      //   {
      //     label: "Full Name",
      //     field: "fullname"
      //   },
      //   {
      //     label: "Email",
      //     field: "email"
      //   },
      //   {
      //     label: "Phone Number",
      //     field: "phonenumber",
      //     type: "number"
      //   },
      //   {
      //     label: "Customer Type",
      //     field: "customertype"
      //   },
      //   {
      //     label: "Last Seen",
      //     field: "lastseen"
      //   }
      // ],
      // rows: [
      //   {
      //     id: 1,
      //     fullname: "John Wick",
      //     email: "johnwick@gmail.com",
      //     phonenumber: "2011-10-31",
      //     customertype: "Agent",
      //     lastseen: "Dec 9, 2017 "
      //   },
      //   {
      //     id: 2,
      //     fullname: "Jane Aniston",
      //     email: "janeaniston@gmail.com",
      //     phonenumber: "2011-10-31",
      //     customertype: "CEO",
      //     lastseen: "14 minutes ago"
      //   },
      //   {
      //     id: 3,
      //     fullname: "Susan Hall",
      //     email: "susanhall@gmail.com",
      //     phonenumber: "2011-10-30",
      //     lastseen: "6 Hours ago"
      //   },
      //   {
      //     id: 4,
      //     fullname: "Chris Pratt",
      //     email: "chrispratt@gmail.com",
      //     phonenumber: "2011-10-11",
      //     customertype: "Manager",
      //     lastseen: "20 Minutes ago"
      //   },
      //   {
      //     id: 5,
      //     fullname: "Dan Schwarz",
      //     email: "danschwarz@gmail.com",
      //     phonenumber: "2011-10-21",
      //     customertype: "Engineer",
      //     lastseen: "5 Minutes ago"
      //   },
      //   {
      //     id: 6,
      //     fullname: "Jax Briggs",
      //     email: "jaxbriggs@gmail.com",
      //     phonenumber: "2011-10-31",
      //     customertype: "Security",
      //     lastseen: "2 Minutes ago"
      //   }
      // ]
    };
  },
  // props: {
  //   pageChanged: {
  //     type: Function
  //   },
  //   perPageChanged: {
  //     type: Function
  //   }
  // },
  methods: {
    random_num: dumm => {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    onSubmit() {
      console.log(this.form);
    },
    // selectAll(selected, selectedRows) {
    //   // do what you want here
    //   console.log(selected, selectedRows);
    // },
    // toggleSelectRow(params) {
    //   // row that was clicked
    //   console.log(params.row);
    //   // index of page
    //   console.log(params.pageIndex);
    //   // whether the row was selected or unselected
    //   console.log(params.selected);
    // },
    // customPageChange(customCurrentPage) {
    //   this.pageChanged({
    //     currentPage: customCurrentPage.push()
    //   });
    // },
    // customPerPageChange(customPerPage) {
    //   this.perPageChanged({
    //     currentPerPage: customPerPage
    //   });
    // },
    init() {
      const token =
        "eyJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..2T4HzSyG2yRal7qRrH46QQ.76im4yKWQUw3rm5RM6KGuQAEDo6Ll-MtfHoLQwhAexJBdJOQqMNPmWwn4X-DYtMxd5FuyZZlRt8XhXc1fvE6smRDH-yD1k5yBXHXP1Da5Oey4Z6udLOMWZalV8ipWijAvxaxFPrmzfxee3tbdYHZtZH7ExsoGtNdiu4q4SyNbOPTxGg7NasW5hb6gJTb116gmPk93ZA_TLc9HewrzsFfMaiQQwsn0DvM6pzTxGbr72RgaYff2vmGomey9io19mBCdxkFWKdn1uMv5Dzb5c3eGt9PfIBfA9WLO06cuQWx-4SXP6EL6a4d83IbA6E0RxmiSzpPFXiXHs8FTr2Qz-vnFigsZqQirmpF8DczFjgm1KhPyxSt5OanMfyC4JoKVXzFexuaLVgQ-001_YxeTAb5EqGly5Xdxhtl2B9b8GaXNveZkWaYqr8gJFxEvZn_RUYmywUnMk8oulFBURPOWphybjnPPdI_2my0Yh940T-1ymmk8-lI14otFkWIl4-wHFNw00bhxu-bav5yFE8c6Ddo9g63MupUGDyTQ5JGef4-rTVqZOQEyLgQWd42hXR6SN1pgXgD6DGMbQ6IJncv1DjFJLsNpyLAkB_YtbemCKGBYMa0vJGdBf2T_KMI37YCkvu23ELB4VPlpIIH2eIVYFFG6fUsmQvzqDQ-5XcriXiWazLfJCdXiA8flizyRltgWGFabLiLkrSnSiJfBgXmC-ZLmVasNBLAxgf-WU_2hBbslq4nJ_HJ_ADiNyhLutBX13EO41w46OdI5IaS5fAGrgBfZ1ZBIkv5aX664yRO4McPIOEqTIJ0feNlkN9elCVPkWNK4KWw8K2P0QLHhYRDNX31aKmoKMmj49WULUeUDwtie-MEtiXv9yPDOZHe4sytTjaJ.k4HxEMIKbZnYGzMHozuFgg";
      const resFormat = "application/json;charset=utf-8";
      axios
        .get(
          "https://sandbox-quickbooks.api.intuit.com/v3/company/4620816365001689780/query?query=select * from Item &minorversion=38",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": `${resFormat}`
            }
          }
        )

        // axios
        //   .post(
        //     "https://sandbox-quickbooks.api.intuit.com/v3/company/4620816365001689780/item?minorversion=38",
        //     {
        //       header: {
        //         Authorization:
        //           `Bearer ${token}`,
        //         "Content-type": `${resFormat}`,
        //         // "Accept": `${resFormat}`
        //       },
        //       data:
        //       {
        //         "TrackQtyOnHand": true,
        //         "Name": "Modems",
        //         "QtyOnHand": 60,
        //         "IncomeAccountRef": {
        //           "name": "Sales of Product Income",
        //           "value": "79"
        //         },
        //         "AssetAccountRef": {
        //           "name": "Inventory Asset",
        //           "value": "81"
        //         },
        //         "InvStartDate": "2019-07-10",
        //         "Type": "Inventory",
        //         "ExpenseAccountRef": {
        //           "name": "Cost of Goods Sold",
        //           "value": "80"
        //         }
        //       }
        //     }
        //   )

        .then(res => {
          this.results = res.data.QueryResponse.Item;
          // this.results = res.data
          // console.log(res.data);
        })
        .catch(error => {
          // console.log(error.config);
          console.log(error);
        });
    },
    test() {
      let items = this.results;
      console.log(items);
    }
  },
  mounted() {
    this.results = this.init();
  },
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/components/pages/kitchen/index.vue